import { CreateFilteredElementConfigurationRequest, FilteredElementConfiguration, FilteredElementConfigurationType, QueryBuildersClient, UpdateFilteredElementConfigurationRequest } from "@api/apiClient";
import axios from "@api/axiosInstance";
import { queryClient } from "@hooks/useGlobalState";
import { useMutation, useQuery } from "@tanstack/react-query";

const queryBuildersClient = new QueryBuildersClient(undefined, axios);

export const useFilteredElementConfigurations = (filteredElementConfigurationType: FilteredElementConfigurationType | null | undefined, options?: any) => {
  return useQuery<FilteredElementConfiguration[]>({
    ...options,
    queryKey: ["filteredElementConfigurations", filteredElementConfigurationType],
    queryFn: async () => queryBuildersClient.getRuleSetFilters(filteredElementConfigurationType),
    placeholderData: [],
    staleTime: 30 * 60 * 1000, // 30 minutes
    cacheTime: 60 * 60 * 1000, // 60 minutes      
  });
};

export const useFilteredElementConfigurationById = (filteredElementConfigurationId: string | undefined, options?: any) => {
  return useQuery<FilteredElementConfiguration | null>({
    ...options,
    queryKey: ["filteredElementConfigurationById", filteredElementConfigurationId],
    queryFn: async () => filteredElementConfigurationId ? queryBuildersClient.getFilteredElementConfiguration(filteredElementConfigurationId!) : new Promise((resolve) => resolve(null)),
  });
};

export const useCreateFilteredElementConfiguration = (options?: any) => {
  return useMutation<FilteredElementConfiguration>({
    ...options,
    mutationFn: (createFilteredElementConfigurationRequest: CreateFilteredElementConfigurationRequest) =>
      queryBuildersClient.createFilteredElementConfiguration(createFilteredElementConfigurationRequest),
    onSuccess: async () => {
      await queryClient.resetQueries({ queryKey: ["filteredElementConfigurations"], exact: false });
      options?.onSuccess?.();
    },
  });
};

export const useUpdateFilteredElementConfiguration = (options?: any) => {
  return useMutation<FilteredElementConfiguration>({
    ...options,
    mutationFn: ({ filteredElementConfigurationId, updateFilteredElementConfigurationRequest }: { filteredElementConfigurationId: string, updateFilteredElementConfigurationRequest: UpdateFilteredElementConfigurationRequest; }) =>
      queryBuildersClient.updateFilteredElementConfiguration(filteredElementConfigurationId, updateFilteredElementConfigurationRequest),
    onSuccess: async () => {
      await queryClient.resetQueries({ queryKey: ["filteredElementConfigurations"], exact: false });
      options?.onSuccess?.();
    },
  });
};